import { type Plugin } from 'vue';
import { createPinia } from 'pinia';

export const setupPinia: () => Plugin = () => createPinia();